// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/**
 * Messages and yes/no questions. The desktop app's web view has no window.alert or
 * window.confirm (WKWebView needs the host to draw them, and Tauri does not: alert shows
 * nothing and confirm answers no), so there they are the system's own dialogs.
 */
import { isDesktop } from "./platform.js";

/** Shows a message and waits until it is dismissed. */
export async function tell(message: string): Promise<void> {
  if (!isDesktop) {
    window.alert(message);
    return;
  }
  const { message: show } = await import("@tauri-apps/plugin-dialog");
  await show(message, { title: "Granite" });
}

/** Asks a yes/no question; true for yes. */
export async function ask(message: string): Promise<boolean> {
  if (!isDesktop) return window.confirm(message);
  const { confirm } = await import("@tauri-apps/plugin-dialog");
  return confirm(message, { title: "Granite" });
}
